// Module
var code = "<svg viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"15.5\" cy=\"24.5\" r=\"2.5\" transform=\"rotate(-90 15.5 24.5)\"/><circle cx=\"15.5\" cy=\"6.5\" r=\"2.5\" transform=\"rotate(-90 15.5 6.5)\"/><circle cx=\"15.5\" cy=\"15.5\" r=\"2.5\" transform=\"rotate(-90 15.5 15.5)\"/></svg>";
// Exports
module.exports = code;